import * as React from 'react';

export default function Wheelchair({ className, viewBox }: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      className={className}
      viewBox={viewBox || '0 0 20 20'}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M15.1915 4.81708C16.2132 4.81708 17.0414 3.98883 17.0414 2.96714C17.0414 1.94544 16.2132 1.11719 15.1915 1.11719C14.1698 1.11719 13.3415 1.94544 13.3415 2.96714C13.3415 3.98883 14.1698 4.81708 15.1915 4.81708Z"
        fill="currentColor"
      />
      <path
        d="M12.4167 14.4923H10.5668C10.5668 16.0185 9.31807 17.2672 7.79186 17.2672C6.26565 17.2672 5.01694 16.0185 5.01694 14.4923C5.01694 12.9661 6.26565 11.7174 7.79186 11.7174V9.86745C5.23893 9.86745 3.16699 11.9394 3.16699 14.4923C3.16699 17.0452 5.23893 19.1172 7.79186 19.1172C10.3448 19.1172 12.4167 17.0452 12.4167 14.4923ZM15.1917 11.2549H13.4712L15.0159 7.86026C15.5801 6.63004 14.6737 5.24258 13.3047 5.24258H8.49484C7.74561 5.24258 7.07038 5.67732 6.76514 6.35255L6.50615 7.05553C6.3119 7.57351 6.60789 8.13775 7.13513 8.28574C7.58837 8.41524 8.0601 8.184 8.2451 7.74926L8.52259 7.09253H10.5668L8.87408 10.8849C8.3191 12.1151 9.23482 13.5673 10.5853 13.5673H15.1917V17.2672C15.1917 17.776 15.6079 18.1922 16.1166 18.1922C16.6254 18.1922 17.0416 17.776 17.0416 17.2672V13.1049C17.0416 12.0874 16.2091 11.2549 15.1917 11.2549Z"
        fill="currentColor"
      />
    </svg>
  );
}
